export enum DispatchTaskStatus {
  LATE = 'Late',
  COMPLETED = 'Completed',
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
  STARTED = 'Started',
  CANCELLED = 'Cancelled',
  NOT_ON_GROUND = 'NotOnGround'
}
